<template>
  <div>
    <vue-element-loading :active="isLoading" :is-full-screen="true" />
    <v-card :loading="isLoading" id="account-setting-card">
      <v-card-title>
        <span class="me-3">{{ $t('pages.create') }} {{ userTypeName }}</span>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="$router.go(-1)" class="mx-1">
          {{ $t('pages.back') }}
          <v-icon right dark> mdi-keyboard-return </v-icon>
        </v-btn>
      </v-card-title>
      <div v-if="userType == 'admin' || userType == 'school'"></div>
      <div v-else>
        <create-user
          :account-data="user"
          :user-type="userType"
          @save-user-info="saveUser"
        ></create-user>
      </div>
    </v-card>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import CreateUser from '@/views/users/partials/create-user.vue';

export default {
  components: {
    VueElementLoading,
    CreateUser,
  },
  data() {
    return {
      isLoading: false,
      userType: null,
      user: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role_id: '',
        parent_ids: [],
        status_id: 1,
        tel_number: '',
        student_identification: '',
        balance: '',
        avatar: '',
        student_school_id: '',
        group_id: '',
        time_from: '',
        time_to: '',
        address: '',
      },
    };
  },
  watch: {
    $route(to, from) {
      this.onRouteChanged();
    },
  },
  mounted() {
    this.onRouteChanged();
  },
  methods: {
    onRouteChanged() {
      this.userType = this.$route.name.split('-')[1];
      if (this.userType === 'student') {
        this.user.role_id = 6;
      } else if (this.userType === 'guardian') {
        this.user.role_id = 4;
      } else if (this.userType === 'driver') {
        this.user.role_id = 3;
      }
    },
    saveUser() {
      this.isLoading = true;
      const data = new FormData();
      for (const key in this.user) {
        if (
          this.userType !== 'student' &&
          (key === 'parent_id' || key === 'parent_ids')
        ) {
          continue;
        }
        data.append(key, this.user[key]);
      }
      const config = {
        headers: { 'content-type': 'multipart/form-data' },
      };
      axios
        .post(`/users/${this.userType}-create`, data, config)
        .then(() => {
          // if (this.userType == 'admin' || this.userType == 'school') {
          //   adminProfileStore.name = this.user.name;
          // }
          this.isLoading = false;
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.user_created') + '!',
            type: 'success',
          });
          this.$router.go(-1);
        })
        .catch(() => {
          this.isLoading = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_creating_user'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        });
    },
  },
  computed: {
    userTypeName() {
      if (!name) return;
      let name = this.$t('pages.' + name);
      name = this.userType?.[0].toUpperCase() + this.userType?.slice(1);
      return name;
    },
  },
};
</script>

<style lang="scss"></style>
